(() => {
  const initialize = () => {
    document.querySelectorAll('[data-fp-monogram]').forEach(marker => {
      if (marker.dataset.initialized) return;
      marker.dataset.initialized = 'true';
      const form = marker.closest('form');
      const scope = form.closest('[data-section-type="product"]') || form.parentElement;
      const variants = JSON.parse(marker.dataset.fpMonogram);
      const monogramIds = new Set(variants.filter(v => v.monogram).map(v => String(v.id)));
      let selectedId = form.querySelector('[name="id"]').value;
      let savedValue = '';
      let previousRequired;
      const getField = () => [...scope.querySelectorAll('#text-area-2898974')].find(el => el.form === form);
      const needsMonogram = () => monogramIds.has(String(selectedId));
      const updateField = () => {
        const field = getField();
        if (!field) return;
        const required = needsMonogram();
        const wrapper = field.closest('.tpo_option-container');
        if (required !== previousRequired) {
          if (!required) {
            if (field.value.trim()) savedValue = field.value;
            field.value = '';
            field.dispatchEvent(new Event('input', {bubbles: true}));
          } else if (savedValue && !field.value) {
            field.value = savedValue;
            field.dispatchEvent(new Event('input', {bubbles: true}));
          }
          previousRequired = required;
        }
        field.disabled = !required;
        field.required = required;
        field.setAttribute('aria-required', String(required));
        field.setAttribute('aria-describedby', marker.id);
        if (wrapper) wrapper.hidden = !required;
        if (!required) {
          field.setCustomValidity('');
          marker.hidden = true;
        }
      };
      const validate = event => {
        updateField();
        if (!needsMonogram()) return true;
        const field = getField();
        if (!field || !field.value.trim()) {
          event.preventDefault();
          event.stopImmediatePropagation();
          marker.textContent = field ? marker.dataset.requiredMessage : marker.dataset.loadingMessage;
          marker.hidden = false;
          if (field) {
            field.setCustomValidity(marker.dataset.requiredMessage);
            field.focus();
            field.reportValidity();
          }
          return false;
        }
        field.setCustomValidity('');
        marker.hidden = true;
        return true;
      };
      document.addEventListener('click', event => {
        const button = event.target.closest('[data-add-to-cart]');
        if (button && button.form === form) validate(event);
      }, true);
      form.addEventListener('submit', validate, true);
      scope.addEventListener('input', event => {
        if (event.target === getField()) {
          if (event.target.value.trim()) savedValue = event.target.value;
          event.target.setCustomValidity('');
          marker.hidden = true;
        }
      });
      document.addEventListener('variant:change', event => {
        const variant = event.detail && event.detail.variant;
        if (!variant || !variants.some(v => String(v.id) === String(variant.id))) return;
        selectedId = variant.id;
        updateField();
      });
      new MutationObserver(updateField).observe(scope, {childList: true, subtree: true});
      updateField();
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize);
  else initialize();
  document.addEventListener('shopify:section:load', initialize);
})();
